// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"survey-start_wrapper__2N9Qv"};